/* eslint-disable @typescript-eslint/no-explicit-any */
import React, { useEffect, useState } from 'react';
import WorkspaceComponent from './tab';
import { useDispatch, useSelector } from 'react-redux';
import { setActiveWorkspace, setIsNewWorkspace, setWorkspaceGroupData, setWorkspaceGroups, updateWorkspacesPlacement } from '../../../store/workspaces/workspaces/actions';
import { WorkspaceButtonBarStyled, WorkspaceContentContainerStyled } from './styles';
import { toast } from '../../../utils/notification';
import { DragDropContext, Droppable } from 'react-beautiful-dnd';
import WorkspacesButtonBar from './components/buttons/tabs.buttonBar';
import BreadcrumbCustom from 'src/components/Header/breadcrumb/Breadcrumb';
import Workspaces from './components/groups/workspaces';
import { WorkspaceService } from 'src/api/services/workspaces/Service.workspace';
import { TabService } from 'src/api/services/workspaces/Service.tab';
import './styles.css';
import { getModules } from 'src/store/workspaces/modules/actions';
import { run as runActions } from '../../../store/workspaces/workspaces/run';
import { defaultWorkspace } from './settings/settings';
import { goHome } from 'src/components/Header/breadcrumb/services/goHome';


const WorkspacesMainstage = () => {
  const workspaces = useSelector((state: any) => state.workspaces);
  const dispatch = useDispatch<any>();
  const [dragEndKey, setDragEndKey] = useState(0);
  const [activeGroupId, setActiveGroupId] = useState(workspaces?.groups[0]);
  const tabService = new TabService();
  const workspaceService = new WorkspaceService();

  useEffect(() => {
    const fetchWorkspaces = async () => {
      try {
        const res = await workspaceService.getAll();
        dispatch(setWorkspaceGroups(res));

        if (!res[0]?.uuid) return;

        await localStorage.setItem('activeWorkspace', JSON.stringify(res[0]));
        const response = await workspaceService.getTabs(res[0]?.uuid);


        if (!response.data.length) {
          dispatch(setWorkspaceGroupData([defaultWorkspace]));
          await goHome();
          await dispatch(getModules());
          return;
        }

        await dispatch(setWorkspaceGroupData(response.data || []));
        await dispatch(setActiveWorkspace(0));
        await runActions(response.data[0].data.key, response.data[0].data.id, response.data[0].data);
        await dispatch(setIsNewWorkspace(0, false));
        await dispatch(getModules());
      } catch (error: any) {
        toast.error('Error fetching workspaces:', error.message);
        throw error;
      }
    };
    fetchWorkspaces();
  }, []);

  const onDragEnd = async (result: any) => {
    if (!result.destination) return;

    if (result.destination.droppableId.startsWith('ws-')) { return console.log(`✅ Gedroppt auf ${result.destination.droppableId}`);}

    const draggedWorkspace = workspaces.instances.splice(result.source.index, 1)[0];
    workspaces.instances.splice(result.destination.index, 0, draggedWorkspace);

    const pinnedWorkspaceUUIDs = workspaces.instances.map((instance) => instance.uuid);
    await tabService.setTabsSequence(pinnedWorkspaceUUIDs);
    await dispatch(updateWorkspacesPlacement(workspaces.instances));
    setDragEndKey((prevKey) => prevKey + 1);
  };

  return (
    <>
      <DragDropContext key={dragEndKey} onDragEnd={onDragEnd}>
        <Droppable
          droppableId="droppable"
          direction="horizontal"
        >
          {(provided) => (
            <>
              <div className="flex justify-between items-center" id="workspace-tabs-container">
                <WorkspaceButtonBarStyled
                  ref={provided.innerRef}
                  {...provided.droppableProps}
                >
                  <WorkspacesButtonBar workspaces={workspaces} />
                  {provided.placeholder}
                </WorkspaceButtonBarStyled>
                <Workspaces
                  activeWsId={activeGroupId}
                  onActiveChange={setActiveGroupId}
                />
              </div>
            </>
          )}
        </Droppable>
      </DragDropContext>

      <BreadcrumbCustom />

      {workspaces.instances.map((workspace: any, index: number) => (
        <WorkspaceContentContainerStyled
          key={index}
          active={+workspace.isActive}
        >
          <WorkspaceComponent workspace={workspace} />
        </WorkspaceContentContainerStyled>
      ))}
    </>
  );
};

export default WorkspacesMainstage;
